import React from 'react';

import { useDispatch } from 'react-redux';

import IconFemtasy from 'components/IconFemtasy';
import Message from 'components/Message';
import { filterUserPlaylists } from 'components/Playlists/hooks/helpers';
import Typography from 'components/Typography';

import {
  PlaylistTypeEnum,
  useUserPlaylistsQuery,
} from 'graphql/generated/graphql';

import useGraphaelDefaults from 'hooks/useGraphaelDefaults';
import { useTracking } from 'hooks/useTracking';

import { openPlaylistCreation } from 'store/modules/playlist';

const CreateNewPlaylist = () => {
  const dispatch = useDispatch();
  const { trackContentInteraction } = useTracking();
  const { data } = useUserPlaylistsQuery({
    ...useGraphaelDefaults(),
    fetchPolicy: 'cache-and-network',
    variables: {
      types: [PlaylistTypeEnum.User],
    },
  });

  return (
    <div
      className="ListItem createNewPlaylist"
      onClick={() => {
        if (data?.playlists) {
          trackContentInteraction(
            'click',
            'playlists-create-new-playlist-button',
            'playlists-create-new-playlist-button',
          );
          const userPlaylists = filterUserPlaylists(data?.playlists);

          dispatch(openPlaylistCreation(userPlaylists.length));
        }
      }}
    >
      <IconFemtasy icon="Plus" />
      <Typography variant="h4">
        <Message message={{ id: 'SM0123.Playlist_Modal.New_playlist' }} />
      </Typography>
    </div>
  );
};

export default CreateNewPlaylist;
